export default "__VITE_ASSET__DhaGnnh3__"